import { apiLogoutAttempt } from './fetcher';
import { AuthType } from '../../types/AuthType';

export default function useLogoutAttempt(setAuth: AuthType | any, setPermissions: any, setRoles: any, setIsLoggedIn: any) {
	const handleLogout = () => {
		const auth: AuthType = {
			currentUser: null,
			accessToken: '',
			initialState: false
		};

		apiLogoutAttempt()
			.then((data) => {
				if (setAuth) {
					setAuth(auth);
				}

				if (setPermissions) {
					setPermissions([]);
				}

				if (setRoles) {
					setRoles([]);
				}

				// if (setIsLoggedIn) {
				// 	setIsLoggedIn(false);
				// }

				window.location.reload();
			})
			.catch((response) => {
				console.error(response);
			});
	};

	return { handleLogout };
}
